/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Board_Move_ToInputs */

const en_board_move_to = /** @type {(inputs: Board_Move_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Move to`)
};

const de_board_move_to = /** @type {(inputs: Board_Move_ToInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verschieben nach`)
};

/**
* | output |
* | --- |
* | "Move to" |
*
* @param {Board_Move_ToInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const board_move_to = /** @type {((inputs?: Board_Move_ToInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Board_Move_ToInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_board_move_to(inputs)
	return en_board_move_to(inputs)
});